







































































import { Component, Vue, Watch } from "vue-property-decorator";
import axios from "axios";
// import DocumentForm from "@/components/DocumentForm.vue";
import DocumentForm from "@/components/DocumentEditForm.vue";
import { authenticationService } from "@/_services";


@Component({ components: { DocumentForm } })
export default class Documents extends Vue {
  private items: any[] = [];
  query = {};
  currentPage = 1;
  defaultSortDir = "desc";
  currentDocument = null;
  searchName = "";
  user: null | undefined;
  modalVisible = false;
  selectedDocumentId = 0;
  documentTypes: [] = [];

  created() {
    authenticationService.currentUser.subscribe((x: null) => {
      this.user = x;
    });
  }

  showModal(documentId) {
    this.selectedDocumentId = documentId;
    this.modalVisible = true;
  }

  get filteredItems() {
    if (this.searchName) {
      var filter = this.searchName.toLowerCase();
      return this.items.filter(
        (it) => it.document_Name.toLowerCase().indexOf(filter) !== -1
      );
    }
    return this.items;
  }

  async mounted() {
    var currentPageRecord = window.localStorage.getItem("documentsPage");
    this.currentPage = currentPageRecord ? parseInt(currentPageRecord) : 1;

    this.documentTypes = (
      await axios.get<[]>("/lookup/document-type", {
        headers: {
          Authorization: "Bearer " + localStorage.token,
        },
      })
    ).data;

    this.load();
  }

  @Watch("$route")
  onRouteChange() {
    this.load();
  }

  @Watch("query", { deep: true })
  onQueryChange() {
    this.search();
  }

  beforeDestroy() {
    window.localStorage.setItem("documentsPage", this.currentPage.toString());
  }

  async load() {
    this.items = (
      await axios.get<[]>("/document", {
        params: this.$route.query,
        headers: {
          Authorization: "Bearer " + localStorage.token,
        },
      })
    ).data;
    for (let item of this.items) {
      item.frequency = this.getShortenedFrequencyString(item.frequency);
    }
  }

  search() {
    this.$router.push({ query: this.query });
  }

  getShortenedFrequencyString(frequency) {
    switch (frequency) {
      case 'mjesečno':
        return 'M';

      case 'tromjesečno':
        return 'T';

      case 'polugodišnje':
        return 'PG';

      case 'godišnje':
        return 'G';

      case 'dvogodišnje':
        return 'DG';

      case 'weekly':
        return 'TJ';
    }
  }

  getUppercaseName(name) {
    const capitalizedFirst = name[0].toUpperCase();
      const rest = name.slice(1);

      return capitalizedFirst + rest;
  }

  resetFilter(){
    this.query = {};
  }

  async deleteDocument(documentId) {
    try {
      await axios.delete(
        `/document/${documentId}`,
        {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        }
      );
      this.load()
    } catch (err) {
      console.log(err);
    }
  }
}
